export default __webpack_public_path__ + "static/media/gloves.beaee140.svg";